import { fetchOffers } from '~/api';

export const retrieveOfferData = async (globalData) => {

  const { host, protocol } = window.location;

  let data;
  try {
    data = await fetchOffers({
      globalData,
      url: `${protocol}//${host}/api/offers`,
    });
  } catch (err) {
    data = undefined;
  }
  return data;
};
